export default "__VITE_ASSET__Blf3p5OP__"